<div [ngClass]="{ 'form-row': to?.className === 'xilo-input' }">
  <div
    class="address-container"
    [ngClass]="{ 'form-item': to?.className === 'xilo-input' }"
  >
    <label class="label">
      {{ to.label }}
      <span *ngIf="to?.required" class="required-indicator">*</span>
      <span
        *ngIf="to.showToolTip"
        mat-icon-button
        aria-label="Tooltip icon"
        [matTooltip]="to.toolTipText"
        matTooltipPosition="above"
      >
        <mat-icon>help_outline</mat-icon>
      </span>
    </label>
    <div class="address-links">
      <div
        class="address-links__item"
        matTooltip="Re-use last address entered"
        *ngIf="to.className === 'intake-input' && to?.showLastAddress === true"
        matTooltipPosition="above"
        (click)="copyAddress()"
      >
        <img class="address-links__item--last-address"
          src="/assets/icons/last-address.svg"
          alt=""
        />
      </div>
      <div
        class="address-links__item"
        matTooltip="Open in Zillow"
        *ngIf="to.className === 'intake-input'"
        matTooltipPosition="above"
        (click)="formControl.value ? openZillow(formControl.value) : ''"
      >
        <img
          [src]="
            formControl.value
              ? '/assets/icons/zillow1.svg'
              : '/assets/icons/zillow.svg'
          "
          alt=""
        />
      </div>
      <div
        *ngIf="to.className === 'intake-input'"
        class="address-links__item"
        matTooltip="View on Google Maps"
        matTooltipPosition="above"
        (click)="openResearchPanel()"
      >
        <img
          [src]="
            formControl.valid
              ? '/assets/icons/search.svg'
              : '/assets/icons/search-disabled.svg'
          "
          alt="open icon"
        />
      </div>
    </div>

    <form autocomplete="off">
      <input type="text" hidden autocomplete="false" />
      <input
        #addressInput
        type="text"
        [class]="to.className || 'xilo-input'"
        [ngClass]="
          changeInputCSS(formControl.invalid, formControl.touched, to.className)
        "
        [formlyAttributes]="field"
        [formControl]="formControl"
        ngx-google-places-autocomplete
        #placesRef="ngx-places"
        (onAddressChange)="handleAddressChange($event)"
        (click)="checkForValidToken()"
        (blur)="touched()"
        (keydown.enter)="$event.preventDefault()"
        (keydown.shift.enter)="$event.preventDefault()"
        (keydown.control.enter)="$event.preventDefault()"
        (keydown.meta.enter)="$event.preventDefault()"
      />
    </form>
    <div *ngIf="to.className === 'intake-input'"  class="flex justify-between">
      <span class="edit-address" (click)="toggleParsedAddressFields(addressIsShowing)">{{ addressFieldText }} </span>

      <mat-icon class="text-sm text-blue-200 items-center justify-end" style="display: flex;"
        matTooltip="Use this to edit address or when there is no option in the Google drop-down."
        matTooltipPosition="above">info</mat-icon>
    </div>
    <!-- errors showing -->
    <label *ngIf="errorMessage" class="invalid-feedback">{{
      errorMessage
    }}</label>
  </div>
</div>
